import moment from "moment";
import { CurrencyFormat } from "../../../../../components/helpers";

export const convertListAgent = (data) => {
  let converted = [];

  if (!data) return [];

  data.forEach((item, index) => {
    converted.push({
      key: index + 1,
      id: item.id,
      dateTime: moment(item.created_at).format("DD/MM/YYYY HH:mm") || "-",
      customerName: item.customer_name || "-",
      npwp: item.npwp_number || "-",
      commissionTotal: `Rp ${CurrencyFormat(item.commission_total)}` || "0",
      notYetDisbursed: `Rp ${
        CurrencyFormat(item.not_yet_disbursed_total) || 0
      }`,
      notYetDisbursedNumber: item.not_yet_disbursed_total || 0,
      accountName: item.bank_account_name || "-",
      bankNameAndNumber:
        `${item.bank_name.toUpperCase()} / ${item.bank_account_number}` || "-",
    });
  });
  return converted;
};
